import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SIZES } from './constants';
import HorizontalStack from '../horizontal-stack';
import ColorTile from '../color-tile';

function ColorTileSelector({
  options,
  size = SIZES.extraLarge,
  value = 'indeterminate',
  onChange,
  onConfigureClick = null,
  indeterminateToolTipText = null,
}) {
  const initialActive = options.find((option) => value === option.id)?.id;
  const [active, setActive] = useState(initialActive || null);
  const [indeterminate, setIndeterminate] = useState(!initialActive);

  const onClick = useCallback(
    (id) => {
      setActive(id);
      setIndeterminate(false);
      onChange(id);
    },
    [onChange]
  );

  useEffect(() => {
    const newActive = options.find((option) => value === option.id)?.id;
    setActive(newActive);
    setIndeterminate(!newActive);
  }, [value, options]);

  return (
    <div className="ws-ui-color-tile-selector">
      <HorizontalStack gap="spacing-3-xs" rowGap="spacing-3-xs" wrap>
        {options.map((option) => (
          <ColorTile
            key={option.id}
            active={active === option.id}
            size={size}
            backgroundColor={option.backgroundColor}
            onClick={() => {
              onClick(option.id);
            }}
            {...(onConfigureClick && { onConfigureClick: () => onConfigureClick(option.id) })}
          />
        ))}
        {indeterminate && (
          <ColorTile
            {...(indeterminateToolTipText ? { tooltipText: indeterminateToolTipText } : null)}
            active
            indeterminate
            size={size}
            onClick={() => {}}
          />
        )}
      </HorizontalStack>
    </div>
  );
}

ColorTileSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
  value: PropTypes.string,
  onConfigureClick: PropTypes.func,
  indeterminateToolTipText: PropTypes.string,
};

export default ColorTileSelector;
